import React, { useState } from 'react';

import CustomBoxApi from 'Api/CRM/Modules/CustomBoxApi';
import LotteriesApi from 'Api/CRM/Modules/LotteriesApi';
import EditButton from 'crm/elements/EditButton';
import Card from 'crm/elements/common/Card';
import TableHead from 'crm/elements/common/TableHead';
import { SelectOptions } from 'crm/elements/formElements/Select';
import { PERMISSION } from 'crm/helpers/Permissions';
import useOnce from 'crm/hooks/useOnce';

const CustomBoxList = () => {
    const [customBoxes, setCustomBoxes] = useState([]);
    const [lotteryNames, setLotteryNames] = useState<SelectOptions>({});

    useOnce(() => CustomBoxApi.getAll().then(setCustomBoxes));
    useOnce(() => LotteriesApi.getNames().then(setLotteryNames));

    return (
        <Card title="Custom Box">
            <table className="table model-list">
                <TableHead>
                    <th>ID</th>
                    <th>Lottery Name</th>
                    <th aria-label="Actions" />
                </TableHead>
                <tbody>
                    {customBoxes.map((box) => (
                        <tr key={box.id}>
                            <td>{box.id}</td>
                            <td>{lotteryNames[box.lottery_id]}</td>
                            <td>
                                <EditButton
                                    url={`/custom_box/${box.id}/`}
                                    permissions={[PERMISSION.UPDATE_CUSTOM_BOX]}
                                />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </Card>
    );
};

export default CustomBoxList;
